var rich_content_viewer_default = {
  "fontElementMap": "TwEQY",
  "wrapper": "Ry7Xl",
  "pluginContainerMobile": "_54vWi",
  "viewer": "zR0e1",
  "android": "Yu5YX",
  "rootedTraversedContent": "_8V9lJ",
  "atomic": "EOD1i",
  "toolbar": "J0T37",
  "block": "VylfZ"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
